import { CalendarClock, HeartHandshake, QrCode } from 'lucide-react';

import { Avatar } from '@/design-system/ui/Avatar';
import { Badge } from '@/design-system/ui/Badge';

import SlideCopy, { FloatingNote } from './SlideCopy';

/** Três etapas da jornada padrão (`DEFAULT_JOURNEY`), com fichas de exemplo. */
const COLUMNS = [
  {
    stage: 'Novo',
    cards: [
      { name: 'Beatriz Lima', note: '1ª visita · dom 12' },
      { name: 'Tiago Rocha', note: '1ª visita · dom 12' },
    ],
  },
  { stage: 'Contatado', cards: [{ name: 'Helena Prado', note: 'Ligar até qui' }] },
  { stage: 'Em integração', cards: [{ name: 'Mateus Alves', note: '3ª visita' }] },
];

/** Destaque dos visitantes: o quadro da jornada e a ficha que chega pelo QR Code do evento. */
export default function VisitorsSlide() {
  return (
    <>
      <SlideCopy
        icon={HeartHandshake}
        tag="Visitantes e integração"
        title="Nenhum visitante fica sem acolhimento."
        text="A ficha chega pelo QR Code do evento, com consentimento, e a equipe de acolhimento acompanha cada passo, do primeiro contato à integração."
      />

      <div aria-hidden className="flex max-w-115 flex-col gap-3">
        <div className="overflow-hidden rounded-card bg-white text-ink shadow-dialog">
          <div className="flex items-center justify-between gap-3 border-b border-line-divider px-4 py-3.5">
            <div>
              <p className="m-0 text-body font-bold">Jornada do visitante</p>
              <p className="m-0 text-meta text-ink-subtle">Fichas e acompanhamentos</p>
            </div>
            <Badge tone="primary">
              <CalendarClock />2 contatos esta semana
            </Badge>
          </div>
          <div className="grid grid-cols-3 items-start gap-2 p-3 pb-9">
            {COLUMNS.map((column) => (
              <div key={column.stage} className="flex flex-col gap-2 rounded-control bg-surface-muted p-2">
                <p className="m-0 flex items-center justify-between px-0.5 text-caption font-semibold text-ink-secondary">
                  {column.stage}
                  <span data-numeric className="text-ink-subtle">
                    {column.cards.length}
                  </span>
                </p>
                {column.cards.map((card) => (
                  <div
                    key={card.name}
                    className="flex items-center gap-1.5 rounded-control bg-white p-1.5 shadow-card"
                  >
                    <Avatar name={card.name} size="xs" />
                    <div className="min-w-0">
                      <p className="m-0 truncate text-caption font-semibold">{card.name.split(' ')[0]}</p>
                      <p className="m-0 truncate text-micro text-ink-subtle">{card.note}</p>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
        <FloatingNote>
          <span className="grid size-9 place-items-center rounded-control bg-accent-pink-soft text-accent-pink">
            <QrCode className="size-4 stroke-2" />
          </span>
          <div>
            <p className="m-0 text-caption text-ink-subtle">Ficha pelo QR Code</p>
            <p className="m-0 text-body font-bold">3 fichas novas no último evento</p>
          </div>
        </FloatingNote>
      </div>
    </>
  );
}
